import { FormattedMessage } from "react-intl";
import BaseButton from "./BaseButton";

const SelectButton = ({ disabled, onClick }) => (
  <BaseButton
    disabled={disabled}
    onClick={onClick}
    tooltip={
      <FormattedMessage id="admin.workspaces.imageSelector.buttons.select.tooltip" />
    }
  >
    <FormattedMessage id="admin.workspaces.imageSelector.buttons.select.title" />
  </BaseButton>
);

export default SelectButton;
